import { memo } from 'react';
import { Check, X } from 'lucide-react';
import { cn } from '@heltarchat/ui';
import { PASSWORD_RULES, isPasswordValid } from '@heltarchat/shared';

// Single source of truth is @heltarchat/shared (same policy the backend
// `passwordSchema` enforces). Re-export so existing importers keep working.
export { PASSWORD_RULES, isPasswordValid };

interface Props {
  value: string;
  className?: string;
}

export const PasswordRequirements = memo(function PasswordRequirements({
  value,
  className,
}: Props) {
  return (
    <ul className={cn('mt-2 flex flex-wrap gap-2', className)}>
      {PASSWORD_RULES.map(rule => {
        const ok = rule.test(value);
        return (
          <li
            key={rule.label}
            className={cn(
              'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors',
              ok
                ? 'border-[var(--heltar-state-success)] text-[var(--heltar-state-success)]'
                : 'border-[var(--heltar-border-input)] text-[var(--heltar-text-secondary)]',
            )}
          >
            {ok ? (
              <Check className='h-3 w-3 shrink-0' />
            ) : (
              <X className='h-3 w-3 shrink-0' />
            )}
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
});
